'use strict';

module.exports = Object.freeze({
  GAME_WIDTH: 750,
  GAME_HEIGHT: 1334,
  MAX_LEVEL: 99,
  PLAYER_STORAGE_KEY: 'star_dodge_player_v1',
  CLIENT_VERSION: '2.1.0',
  PENDING_RUN_FINISHES_STORAGE_KEY: 'star_dodge_pending_run_finishes_v1',
  DASHBOARD_STORAGE_KEY: 'star_dodge_dashboard_v1',
  LEADERBOARD_STORAGE_KEY: 'star_dodge_leaderboard_v1',
  GAME_CONFIG_STORAGE_KEY: 'star_dodge_game_config_v1',
  SETTINGS_STORAGE_KEY: 'star_dodge_settings_v1',
  TUTORIAL_STORAGE_KEY: 'star_dodge_tutorial_seen_v1',
  TOUCHPAD_TUTORIAL_STORAGE_KEY: 'star_dodge_touchpad_tutorial_seen_v1',
  COLORS: Object.freeze({
    backgroundTop: '#07122d',
    backgroundBottom: '#020611',
    cyan: '#46e6ff',
    blue: '#4285ff',
    purple: '#a855f7',
    danger: '#ff496c',
    warning: '#ffb238',
    success: '#55f59a',
    text: '#f4f8ff',
    muted: '#91a4c9',
    panel: 'rgba(9, 24, 58, 0.88)'
  })
});
